// extracted by mini-css-extract-plugin
export default {"root":"OverLengthColumn_root__Xp3gl","name":"OverLengthColumn_name__FdoU7"};